/* eslint-disable no-unused-vars */
import {
  QuestionFormFieldWithOptions,
  QuestionFormFieldWithOptionsType,
} from './questionFormFieldWithOptions'

/**
 * Creates an instance of RadioField.
 * @typedef {Object} RadioFieldType
 * @property {boolean} inline
 *
 * @typedef {QuestionFormFieldWithOptionsType & RadioFieldType} RadioFieldExtendType
 */

/**
 * Represents a select box form field.
 * @class
 */
export class RadioField extends QuestionFormFieldWithOptions {
  /**
   * Create a new TextField.
   * @param {RadioFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.inline = params.inline
  }
}
